import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';

const NotFound = () => {
  return (
    <Container>
      <Row className="justify-content-center mt-5">
        <Col md={8} lg={6}>
          <Card className="text-center shadow-sm">
            <Card.Body className="p-5">
              <FaExclamationTriangle size={50} className="text-warning mb-3" />
              <h2>Seite nicht gefunden</h2>
              <p className="text-muted mb-4">
                Die angeforderte Seite existiert nicht oder wurde verschoben.
              </p>
              <Button as={Link} to="/" variant="primary">
                <FaHome className="me-2" /> Zuru00fcck zur Startseite
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
